<template>
	<m-layout>
    <div fill-height class="fill-height" style="width:100%">
      <v-dialog v-model="dialog" width="400px">
        <img :src="ticketUrl" width="400px"/>
      </v-dialog>
      <m-confirm ref="confirm"></m-confirm>
      <v-card-title>
        <span class="headline">Tickets</span>
          <v-btn icon class="mx-0" @click="onRefresh">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
      </v-card-title>

            <v-spacer></v-spacer>
            <v-layout wrap grid-list-md>

                    <v-flex xs12 class="px-1">
                    <v-card>
                      <v-card-title>
                        <v-toolbar flat class="tm-toolbar">
                           <v-text-field
                                append-icon="search"
                                label="Booking id"
                                single-line
                                hide-details
                                v-model="bookingId"
                                @change="getData"
                              ></v-text-field>
                              <v-spacer></v-spacer>
                              <v-text-field
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                v-model="search"
                              ></v-text-field>
                      </v-toolbar>
                      </v-card-title>

                      <v-data-table
                          v-bind:headers="headers"
                          v-bind:items="tickets"
                          :search="search"
                          :options.sync="options"
                          :footer-props="{
                            'items-per-page-options': [5, 20, {text:'All', value:-1}]
                          }"
                        >
                        <template v-slot:body="{ items }">
                          <tbody>
                            <tr v-for="item in items" :key="item.name">

                            <td >{{ item.bookingId }}</td>
                            <td >{{ item.ticketId }}</td>
                            <td >{{ item.driver.lastname }} {{ item.driver.firstname }}</td>
                            <td >{{ item.date }}</td>
                            <td >
                              <a :href="item.imageUrl" target="_blank">photo</a>
                            </td>
                            <td class="justify-center layout px-0">
                              <v-btn icon class="mx-0" @click.stop="detailItem(item)">
                                <v-icon color="primary">visibility</v-icon>
                              </v-btn>
                              <v-btn icon class="mx-0" @click.stop="deleteItem(item)">
                                <v-icon color="primary">delete</v-icon>
                              </v-btn>
                            </td>
                            </tr>
                          </tbody>
                        </template>
                        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                          From {{ pageStart }} to {{ pageStop }}
                        </template>
                      </v-data-table>
                  </v-card>
                    </v-flex>

            </v-layout>

    </div>
	</m-layout>
</template>
<script>
import Confirm from '@/components/confirm.vue'
import TicketsgMixin from '@/mixins/tickets'
export default {
  mixins: [TicketsgMixin],
  components: {
    'm-confirm': Confirm
  },
  data () {
    return {
      dialog: false,
      search: '',
      options: null,
      headers: [
        { text: 'Booking ID', value: 'bookingId' },
        { text: 'Ticket ID', value: 'ticketId' },
        { text: 'Driver', value: 'driver' },
        { text: 'Date', value: 'date' },
        { text: 'Image', value: 'imageUrl' }
      ],
      items: [],
      bookingId: null,
      tickets: [],
      ticketUrl: null
    }
  },
  methods: {
    detailItem (item) {
      console.log(item);
      this.ticketUrl = item.imageUrl;
      this.dialog = true;
    },
    deleteItem (item) {
      this.deleteTicket(item.bookingId)
      .then(() => {
          this.getData()
      });
    },
    getData () {
      this.getTickets(this.bookingId);
      this.getLocations('087079825976');
    },
    onRefresh () {
      this.getData();
    }
  },
  created () {
    this.getData();
  }
};
</script>
<style lang="scss">
</style>
